import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const DoubleArrowIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M0.75 8H16.75M0.75 8L5.25 3.5M0.75 8L5.25 12.5M16.75 8L12.25 3.5M16.75 8L12.25 12.5" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

DoubleArrowIcon.displayName = 'DoubleArrowIcon';
